export const IRIPrefix = '#';

export function IRIToId(IRI: string): string {
  return IRI?.split(IRIPrefix)[1];
}

export function IdToIRI(id: string): string {
  return 'http://nowords.com#' + id;
}
